<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editForm" ref="editFormRef" label-width="90px">
          <el-form-item label="归属机构" class="addAdminForm">
            <el-select v-model="editForm.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" class="addAdminForm">
            <el-date-picker v-model="editForm.riqi" type="date" placeholder="日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="类别" class="addAdminForm">
            <el-select v-model="editForm.leibie" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianFeiYongLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" class="addAdminForm">
            <el-input v-model="editForm.amount" placeholder="请输入金额"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="editForm.beizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editForm: {
        id: '0',
        jigouid: '0',
        jigouname: '',
        riqi: '',
        leibie: '-1',
        amount: '0',
        beizhu: ''
      },
      RuiShiLiYanKeMenDian:[],
      RuiShiLiYanKeMenDianFeiYongLeiBie:[],
    }
  },
  mounted () {
    this.RuiShiLiYanKeMenDian = Vue.prototype.FunGetRuiShiLiYanKeMenDian()
    this.RuiShiLiYanKeMenDianFeiYongLeiBie = Vue.prototype.FunGetRuiShiLiYanKeMenDianFeiYongLeiBie()
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.jigouid = row.Jigouid.toString()
      this.editForm.jigouname = row.Jigouname
      this.editForm.riqi = row.Riqi
      this.editForm.leibie = row.Leibie.toString()
      this.editForm.amount = row.Amount
      this.editForm.beizhu = row.Beizhu
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditMenDianPurchaseSalesFeiYongLuRu()
    },
    apiEditMenDianPurchaseSalesFeiYongLuRu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        jigouid: that.editForm.jigouid,
        riqi: that.editForm.riqi,
        leibie: that.editForm.leibie,
        amount: that.editForm.amount,
        beizhu: that.editForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditMenDianPurchaseSalesFeiYongLuRu, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
